import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Popup.css';

const StudioRulesPopup = ({ onClose, title, content }) => {
  const { t, i18n } = useTranslation();
  const isSlovak = i18n.language === 'sk';

  // Prevent background scrolling when popup is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  // If title and content are provided, use them; otherwise, show default studio rules
  const popupTitle = title || (isSlovak ? 'Pravidlá štúdia' : 'Studio Rules');
  const hasCustomContent = !!content;

  return (
    <div className="popup-overlay">
      <div className="popup-container studio-rules-popup">
        <div className="popup-header">
          <h2>{popupTitle}</h2>
          <button className="popup-close" onClick={onClose}>×</button>
        </div>
        <div className="popup-content">
          {hasCustomContent ? (
            <div className="studio-rules custom-content">
              {content}
            </div>
          ) : isSlovak ? (
            <div className="studio-rules">
              <h3>Pravidlá štúdia</h3>
              
              <div className="rules-section">
                <h4>Úcta a nenásilie k vlastnému telu</h4>
                <ul className="rules-list">
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">🧘</span>
                      <p>Vyberám si lekciu na základe náročnosti, ktorá je pre mňa zvládnuteľná. Popis každej lekcie, jej obťažnosť, aj inštrukcie k tomu, pre koho je vhodná, si vopred prečítam priamo v popise tej lekcie, na ktorú sa hlásim.</p>
                    </div>
                  </li>
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">🌿</span>
                      <p>Počúvam svoje telo a nenútim ho robiť veci, na ktoré sa práve necíti. Netlačím sa do pozícií, neporovnávam sa s ostatnými, nemeriam svoje sily a schopnosti.</p>
                    </div>
                  </li>
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">👣</span>
                      <p>Na podložkách sa cvičí naboso kvôli stabilite, energii, uzemneniu, lepšiemu vnímaniu a prekrveniu chodidiel.</p>
                    </div>
                  </li>
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">🚻</span>
                      <p>V štúdiu na toaletách nájdem zopár hygienických pomôcok, ktoré sú pre nás všetkých.</p>
                    </div>
                  </li>
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">💧</span>
                      <p>Dodržujem základy hygieny.</p>
                    </div>
                  </li>
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">🧠</span>
                      <p>Lektor nie je môj "odborný" lekár, životný kouč, ani psychológ - môj učiteľ mi poradí ako dýchať, ako cvičiť, meditovať.</p>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="rules-section">
                <h4>Rezervácia – príchod, odchod</h4>
                <ul className="rules-list">
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">📱</span>
                      <p>Rezervácia hodiny online cez rezervačný systém na web stránke najneskôr 12 hodín pred začiatkom.</p>
                    </div>
                  </li>
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">⏰</span>
                      <p>Lekciu zruším najneskôr 12 hodín pred jej začiatkom. V prípade nečakaných udalostí kontaktujem tím štúdia cez e-mail alebo FB/IG.</p>
                    </div>
                  </li>
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">💸</span>
                      <p>V prípade, že sa neodhlásim z lekcie, beriem na vedomie, že som povinný/á uhradiť plnú sumu.</p>
                    </div>
                  </li>
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">⌚</span>
                      <p>Na každú lekciu prídem v predstihu aby som mal/a čas sa pripraviť. Beriem na vedomie že lekcie sa začínajú na čas. Nerušme sa navzájom neskorým príchodom.</p>
                    </div>
                  </li>
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">🔔</span>
                      <p>Ak mám nejaké fyzické obmedzenia, zranenia informujem lektorku pred hodinou.</p>
                    </div>
                  </li>
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">📵</span>
                      <p>Pri vstupe do štúdia si vypínam zvonenie, vibrovanie mobilného telefónu a hodiniek.</p>
                    </div>
                  </li>
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">👟</span>
                      <p>Pred vstupom do štúdia sa vyzujem a uložím topánky do regála. Bundy, mikiny si vyzlečiem na chodbe, je tam priestor na odloženie.</p>
                    </div>
                  </li>
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">🧹</span>
                      <p>Spoločné podložky po každej lekcii vydezinfikujem, utriem a odložím na svoje miesto.</p>
                    </div>
                  </li>
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">🫂</span>
                      <p>Rešpektujem osobný priestor ostatných.</p>
                    </div>
                  </li>
                  <li>
                    <div className="rule-item">
                      <span className="rule-icon">🚗</span>
                      <p>Do 17:00 hodiny neparkujem priamo pred budovou štúdia, ale na parkovisku pred Kauflandom.</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          ) : (
            <div className="studio-rules">
              <h3>Studio Rules</h3>
              <p>This is the English version of the Studio Rules. Please switch to Slovak language to view the full rules.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudioRulesPopup; 